<template>
  <div class="customer-detail" v-if="user">
    <template v-if="detail && detail.length > 0">
      <template v-for="(item, index) in detail">
        <div :key="`${index}_${item.emp_id}`" class="pa-2">
          <div class="title primary--text">{{ item.redeem_detail }}</div>
          <v-layout>
            <v-flex class="caption grey--text">{{
              item.redeem_date | dateFormat('DD MMM YYYY')
            }}</v-flex>
            <v-flex class="text-xs-right">{{ item.redeem_point }}</v-flex>
          </v-layout>
          <div
            v-if="item.remark"
            class="mt-1 mb-1 pa-2"
            style="border: 1px solid #eee;background: #f7f7f7;"
          >
            {{ item.remark }}
          </div>
          <div class="text-xs-right">
            <template v-if="item.status">
              <v-chip
                small
                :color="item.status == 'Approve' ? 'success' : 'danger'"
                class="white--text"
                disabled
                round
                >{{ item.status }}</v-chip
              >
            </template>
            <template v-else>
              <v-chip small class="white--text" disabled round>Not Assign</v-chip>
            </template>
          </div>
        </div>
        <v-divider :key="`${index}_${item.emp_id}_line`"></v-divider>
      </template>
    </template>
    <div v-else class="text-xs-center pt-4 pb-4">
      No Data
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import config from '@/config'
import CustomerItemValue from './CustomerItemValue'
import EditCustomerValue from './EditCustomerValue'
import specialtext from '@/components/elements/specialtext'
import Tags from '@/components/elements/Tags'
import api from '@/api'
export default {
  props: {
    value: {
      default: undefined
    },
    show: {
      default: false
    }
  },
  data: function() {
    return {
      user: undefined,
      detail: []
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  mounted: function() {
    this.user = this.value
  },
  methods: {
    getHafeleRedeemDetailByEmpid() {
      var vm = this
      return new Promise((resolve, reject) => {
        var data = {
          emp_id: this.user.emp_id
        }
        api.getHafeleRedeemDetailByEmpid(data, function(error, response) {
          if (error) {
            reject(error)
          }
          resolve(response)
        })
      })
    }
  },
  watch: {
    value: function() {
      this.user = this.value
    },
    show: function(newVal) {
      var vm = this
      if (newVal == true && vm.user) {
        vm.loading = true
        vm.getHafeleRedeemDetailByEmpid().then(function(response) {
          vm.detail = response.data
          vm.loading = false
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/dashboard/HafeleCustomerDetail.vue